import Vue from 'vue'
import VueRouter from 'vue-router'
import loginView from '../views/loginView.vue'
import syssetView from '../views/sysset/index.vue'
import TopicsView from '../views/topics/index.vue'
import TopicsDetail from '../views/topics/detail.vue'
import singupView from '../views/singup/index.vue'
import TopicsFileView from '../views/topics/file.vue'
import TopicsRecycleView from '../views/topics/recycle.vue'
import feedbackView from '../views/feedback/index.vue'
import indexView from '../views/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: loginView
  },
  {
    path: '/topics',
    name: 'topics',
    component: TopicsView
  },
  {
    path: '/topicsfile',
    name: 'topicsfile',
    component: TopicsFileView
  },
  {
    path: '/topicsrecycle',
    name: 'topicsrecycle',
    component: TopicsRecycleView
  },
  {
    path: '/topics/detail',
    name: 'topicsdetail',
    component: TopicsDetail
  },
  {
    path: '/sysset',
    name: 'sysset',
    component: syssetView
  },
  {
    path: '/singup',
    name: 'singup',
    component: singupView
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: feedbackView
  },
  {
    path: '/indexxx',
    name: 'index',
    component: indexView
  }
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
